export function suggestXPath(_doc, target) {
    const indexTargetIdx = target.kind === 'elem' && target.elementPath.length >= 2
        ? target.elementPath.length - 2
        : target.elementPath.length - 1;
    const segs = target.elementPath.map((n, i) => {
        if (target.kind === 'elem' &&
            i === indexTargetIdx &&
            target.siblingIndex &&
            target.siblingIndex > 1) {
            return `${n}[${target.siblingIndex}]`;
        }
        return n;
    });
    if (target.kind === 'attr') {
        const xpath = '/' + segs.join('/') + '/@' + target.attrName;
        const description = `the @${target.attrName} attribute of ${segs[segs.length - 1] ?? 'root'}`;
        return { xpath, description };
    }
    const xpath = '/' + segs.join('/');
    const last = segs[segs.length - 1] ?? 'root';
    const description = `the ${last} element`;
    return { xpath, description };
}
//# sourceMappingURL=xml-suggest.js.map